import * as React from 'react';
import { Link } from 'react-router';
import * as _ from 'underscore';

import Amenities from './Amenities';

import RoomTypeDescriptionRepository from '../../repositories/RoomTypeDescriptionRepository';
import RoomTypeRepository from '../../repositories/RoomTypeRepository';
import RoomTypeDescription from '../../models/RoomTypeDescription';
import RoomType from '../../models/RoomType';

import './synopsis.less';

interface P {
    folding?: boolean;
}

export default class Synopsis extends React.Component<P, {
    descriptions?: RoomTypeDescription[];
    types?: RoomType[];
}> {

    static contextTypes: React.ValidationMap<any> = {
        room_type_description_repository: React.PropTypes.object,
        room_type_repository: React.PropTypes.object
    }

    context: {
        room_type_description_repository: RoomTypeDescriptionRepository;
        room_type_repository: RoomTypeRepository;
    };

    constructor( props: P, context: any ) {
        super( props, context );

        this.state = { descriptions: [], types: [] };
    }

    componentDidMount() {
        this.list();
    }

    private list() {
        this.context.room_type_description_repository.findAll().
             done( data => this.setState({ descriptions: data }) );
        this.context.room_type_repository.findAll().
             done( data => this.setState({ types: data }) );
    }

    render() {
        return (
            <div className="synopsis component">
              { this.state.descriptions.map( it => {
                    let price = _.chain(this.state.types).
                                  where({ name: it.alias || it.name }).
                                  pluck('price').
                                  pluck('nightly').
                                  min().
                                  value();
                    let priceDiv: JSX.Element = null;
                    if ( _.isFinite(price) )
                        priceDiv = (
                            <div className="price">
                              <span className="night">{ price / 100 }</span>
                              <span className="week"></span>
                            </div>
                        );

                    return (
                        <div className={ it.route } key={ it.route }>
                          <h3>{ it.name }</h3>
                          <img src={ it.image } />
                          <Amenities typename={ it.name } folding={ this.props.folding } />
                          { priceDiv }
                          <div className={ `cap x${it.capability}` }></div>
                          <Link to={ `/${it.route}` }></Link>
                        </div>
                    );
                } ) }
            </div>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/rooms/Synopsis.tsx
 **/